
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fitkonnekt",
      function () {
        return require("private-next-pages/fitkonnekt/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fitkonnekt"])
      });
    }
  